export const USER_MODEL = "user";
export const USER_STAFF_MODEL = "users/staff-account";
export const USERS_TO_IMPERSONATE = "users/to-impersonate";

const userModel = {
  firstName: "",
  lastName: "",
  age: 0,
  dob: "",
  email: "",
  phone: "",
  gender: "",
  cisgendered: false,
  mobile: "",
  fax: "",
  cv: "",
  website: "",
  awr: false,
  dda: false,
  password: "",
  countryOfBirth: "",
  ethnicGroupId: "",
  isBilling: false,
  accountType: "",
  approverLevelNbr: "",
  utr: "",
  yearsReferenced: null,
  complianceSupportingFile: [],
  ethnicOrigin: {},
  userComplianceChecks: [],
  userReferences: [],
  roles: [],
  minimumSalaryPreference: 0,
  status: "",
  hasConnectedCalendar: false,
  unspentCriminalConvictions: "",
  isRedeploymentCandidate: false,
  isInternalCandidate: false,
  inviteDate: "",
  lastSessionDate: "",
  detailedStatus: "",
  inTalentPool: false,
  users: [],
  address: {
    line1: "",
    line2: "",
    line3: "",
    postCode: "",
    country: ""
  },
  addresses: {
    jsonApi: "hasMany",
    type: "addresses"
  },
  applications: {
    jsonApi: "hasMany",
    type: "applications"
  },
  organisations: {
    jsonApi: "hasMany",
    type: "organisations"
  },
  organisation: {
    jsonApi: "hasOne",
    type: "organisations"
  },
  intermediaryOrganisation: {
    jsonApi: "hasOne",
    type: "organisations"
  },
  events: {
    jsonApi: "hasMany",
    type: "event"
  },
  complianceChecks: {
    jsonApi: "hasMany",
    type: "compliance-checks"
  },
  references: {
    jsonApi: "hasMany",
    type: "references"
  },
  experienceFunctions: {
    jsonApi: "hasMany",
    type: "experience-functions"
  },
  locationGroupings: {
    jsonApi: "hasMany",
    type: "location-groupings"
  },
  contractTypesGroupings: {
    jsonApi: "hasMany",
    type: "contract-types-groupings"
  },
  workingHoursGroupings: {
    jsonApi: "hasMany",
    type: "working-hours-grouping"
  },
  languages: {
    jsonApi: "hasMany",
    type: "languages"
  },
  experiences: {
    jsonApi: "hasMany",
    type: "experiences"
  },
  qualifications: {
    jsonApi: "hasMany",
    type: "qualifications"
  },
  interviewSlots: {
    jsonApi: "hasMany",
    type: "interview-slots"
  },
  offers: {
    jsonApi: "hasMany",
    type: "offers"
  },
  conversations: {
    jsonApi: "hasMany",
    type: "conversations"
  }
};

export const USER_SELF_MODEL = "self";
export const INVITE_USER = "invite";

export default userModel;
